export function fetch(id) { return { type: 'ALUMNI/FETCH', id } }


// WEBPACK FOOTER //
// ./src/redux-sagas/actions/alumni.js